import React from 'react';

export default class View extends React.Component{

  getYT(link) {
    return(
      <iframe
        className='yt-video-plano'
        height="480"
        src={link}
        frameBorder="0" 
        allowFullScreen
        >
      </iframe>
    );
  }

  render(){
    const data = this.props.data;
    const imagem = data.imagem ? <div className='img-plano'><img src={data.imagem} /></div> : null;
    const descricao = data.plano ? <div className='plano-descricao'>{data.plano}</div> : null;
    const link = data.link ? this.getYT(data.link) : null;
    return(
      <div>
        {imagem}
        {descricao}
        {link}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/meu-plano-alimentar/View.js